'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);
    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
}
var enhancer = function enhancer(WrappedComponent) {
  return function (_WrappedComponent) {
    _inherits(Progress, _WrappedComponent);
    function Progress() {
      _classCallCheck(this, Progress);
      return _possibleConstructorReturn(this, _WrappedComponent.apply(this, arguments));
    }
    Progress.prototype.componentDidUpdate = function componentDidUpdate() {
      var now = Date.now();
      this.path.style.transitionDuration = '0.3s, 0.3s';
      if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
        this.path.style.transitionDuration = '0s, 0s';
      }
      this.prevTimeStamp = Date.now();
    };
    Progress.prototype.render = function render() {
      return _WrappedComponent.prototype.render.call(this);
    };
    return Progress;
  }(WrappedComponent);
};
exports["default"] = enhancer;
module.exports = exports['default'];